import React from 'react';
import LegalLayout from '../components/LegalLayout';
import { Mail, Clock, MessageSquare } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Contact() {
  return (
    <LegalLayout title="Contact us" lastUpdated="February 26, 2026">
      <p>
        Questions, feedback, billing issues, or partnership inquiries — we'd love to hear from you.
      </p>

      <div className="not-prose grid grid-cols-1 sm:grid-cols-2 gap-4 my-6">
        <a
          href="mailto:xpertzankur@gmail.com"
          className="block bg-slate-800/60 border border-slate-700 hover:border-amber-400/50 rounded-xl p-5 transition"
          data-testid="contact-email-link"
        >
          <Mail className="w-6 h-6 text-amber-400 mb-2" />
          <div className="text-sm text-slate-400 mb-0.5">Email (preferred)</div>
          <div className="text-white font-semibold">xpertzankur@gmail.com</div>
          <div className="text-xs text-slate-500 mt-1">Replies within 2 business days</div>
        </a>

        <Link
          to="/"
          className="block bg-slate-800/60 border border-slate-700 hover:border-amber-400/50 rounded-xl p-5 transition"
        >
          <MessageSquare className="w-6 h-6 text-amber-400 mb-2" />
          <div className="text-sm text-slate-400 mb-0.5">In-app feedback</div>
          <div className="text-white font-semibold">Click the "Feedback" button</div>
          <div className="text-xs text-slate-500 mt-1">Bottom-left of the studio</div>
        </Link>
      </div>

      <h2>What to include in your email</h2>
      <ul>
        <li>Your account email address (if you have one)</li>
        <li>For billing issues: transaction ID and date</li>
        <li>For bug reports: a screenshot and brief description of what you were doing</li>
        <li>For feature requests: what problem you're trying to solve</li>
      </ul>

      <h2>Business / partnership inquiries</h2>
      <p>
        For team licensing, white-label arrangements, integrations, or media inquiries, please write
        "<strong>Business Inquiry</strong>" in your email subject line so we can prioritize your message.
      </p>

      <h2>Response times</h2>
      <p className="not-prose flex items-center gap-2 text-sm text-slate-400">
        <Clock className="w-4 h-4 text-amber-400" />
        Monday–Friday, replies within 2 business days. Weekend and holiday messages are answered on the next business day.
      </p>

      <h2>Operator</h2>
      <p>
        Facade Lighting Studio is operated independently. For all communications use the email address above. If you need
        a postal address for legal notices, request one in your email and we will share it confidentially.
      </p>
    </LegalLayout>
  );
}
